module.exports = __webpack_public_path__ + "static/media/37.fb0376b3.mp3";